import React, { useContext } from 'react';
import { IconProps } from '../iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconGltf({
  isAutoscallable = true,
  sizeKey = '17x22',
  onClick,
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 17 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9219 5.78944V20.263C16.9219 21.2224 16.1416 22 15.1794 22H1.82059C0.858094 22 0.078125 21.2224 0.078125 20.263V1.73697C0.078125 0.777562 0.858094 0 1.82059 0H11.1135L16.9219 5.78944Z"
        fill="#76B8B7"
      />
      <path
        d="M5.17676 16.5596C5.2666 16.6357 5.41797 16.6738 5.63086 16.6738C5.93164 16.6738 6.13281 16.5732 6.23438 16.3721C6.30078 16.2432 6.33398 16.0264 6.33398 15.7217V15.5166C6.25391 15.6533 6.16797 15.7559 6.07617 15.8242C5.91016 15.9512 5.69434 16.0146 5.42871 16.0146C5.01855 16.0146 4.69043 15.8711 4.44434 15.584C4.2002 15.2949 4.07812 14.9043 4.07812 14.4121C4.07812 13.9375 4.19629 13.5391 4.43262 13.2168C4.66895 12.8926 5.00391 12.7305 5.4375 12.7305C5.59766 12.7305 5.7373 12.7549 5.85645 12.8037C6.05957 12.8877 6.22363 13.042 6.34863 13.2666V12.8066H7.16016V15.8359C7.16016 16.248 7.09082 16.5586 6.95215 16.7676C6.71387 17.127 6.25684 17.3066 5.58105 17.3066C5.17285 17.3066 4.83984 17.2266 4.58203 17.0664C4.32422 16.9062 4.18164 16.667 4.1543 16.3486H5.0625C5.08594 16.4463 5.12402 16.5166 5.17676 16.5596ZM5.03613 14.9102C5.14941 15.1797 5.35254 15.3145 5.64551 15.3145C5.84082 15.3145 6.00586 15.2412 6.14062 15.0947C6.27539 14.9463 6.34277 14.7109 6.34277 14.3887C6.34277 14.0859 6.27832 13.8555 6.14941 13.6973C6.02246 13.5391 5.85156 13.46 5.63672 13.46C5.34375 13.46 5.1416 13.5977 5.03027 13.873C4.97168 14.0195 4.94238 14.2002 4.94238 14.415C4.94238 14.6006 4.97363 14.7656 5.03613 14.9102Z"
        fill="white"
      />
      <path d="M7.89996 11.6816H8.73492V16H7.89996V11.6816Z" fill="white" />
      <path
        d="M10.9542 15.4053V16.0293L10.5587 16.0439C10.1642 16.0576 9.89465 15.9893 9.75012 15.8389C9.65637 15.7432 9.60949 15.5957 9.60949 15.3965V13.4307H9.16418V12.8359H9.60949V11.9453H10.4357V12.8359H10.9542V13.4307H10.4357V15.1182C10.4357 15.249 10.4523 15.3311 10.4855 15.3643C10.5187 15.3955 10.6202 15.4111 10.7902 15.4111C10.8155 15.4111 10.8419 15.4111 10.8693 15.4111C10.8986 15.4092 10.9269 15.4072 10.9542 15.4053Z"
        fill="white"
      />
      <path
        d="M12.9274 11.6553V12.335C12.8805 12.3291 12.8014 12.3252 12.6901 12.3232C12.5807 12.3193 12.5046 12.3438 12.4616 12.3965C12.4206 12.4473 12.4001 12.5039 12.4001 12.5664V12.8359H12.9479V13.4248H12.4001V16H11.568V13.4248H11.1022V12.8359H11.5593V12.6309C11.5593 12.2891 11.6169 12.0537 11.7321 11.9248C11.8532 11.7334 12.1452 11.6377 12.6081 11.6377C12.6608 11.6377 12.7087 11.6396 12.7516 11.6436C12.7946 11.6455 12.8532 11.6494 12.9274 11.6553Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9211 5.46528V6.18578H12.1729C11.1897 6.18578 10.7363 5.38828 10.7363 4.40481V0H11.4555L16.9211 5.46528Z"
        fill="#AFDCDB"
      />
    </svg>
  );
}
